import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cls from "./AdvantagesSection.module.scss";
import CheckIcon from "../../../shared/ui/CheckIcon/CheckIcon";
const advantages = [
    {
        title: "Proven expertise",
        description: "A skilled team combining strategic thinking with hands-on performance execution.",
    },
    {
        title: "Results-driven approach",
        description: "We focus on metrics that directly impact your business growth.",
    },
    {
        title: "Full transparency",
        description: "Clear reporting and open communication — you always know how your budget is being used.",
    },
    {
        title: "Continuous optimization",
        description: "We constantly test and refine campaigns to keep performance improving and costs under control.",
    },
];
export default function AdvantagesSection() {
    return (_jsx("section", { id: "benefits", className: cls.section, children: _jsx("div", { className: cls.container, children: _jsxs("div", { className: cls.grid, children: [_jsxs("div", { className: cls.content, children: [_jsx("h2", { className: cls.title, children: "What sets us apart" }), _jsx("div", { className: cls.list, children: advantages.map((advantage, index) => (_jsxs("div", { className: cls.item, children: [_jsx("div", { className: cls.checkIcon, children: _jsx(CheckIcon, {}) }), _jsxs("div", { className: cls.itemContent, children: [_jsx("h3", { className: cls.itemTitle, children: advantage.title }), _jsx("p", { className: cls.itemDescription, children: advantage.description })] })] }, index))) })] }), _jsx("div", { className: cls.imageWrapper, children: _jsx("img", { src: "/images/advantages-image.png", alt: "Team collaboration and discussion", className: cls.image }) })] }) }) }));
}
